// Module
var code = "<ol class=\"breadcrumb\"> <li ng-repeat=\"step in steps\" ng-class=\"{active: $last}\" ng-switch=\"$last\"> <span>{{step.ncyBreadcrumbLabel}}</span> </li> </ol>";
// Exports
var _module_exports =code;;
var path = 'common/breadcrumbsTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;